import { useEffect, useState, Suspense } from 'react'
import axios from 'axios'
import {
  Spinner,
  ContentSection,
  PageWrap,
  Table,
} from '@vwfs-bronson/bronson-react'

interface Package {
  name: string
  version: string
  copyright: string
}

interface License {
  license: string
  licenses: string
  name: string
  displayName: string
  licenseLink: string
  packages: Package[]
  licenseText: string
  repository: string
  publisher: string
}

const ThirdPartyLicensePage = () => {
  const [licenses, setLicenses] = useState<License[]>([])
  const [isLoading, setIsLoading] = useState<boolean>(true)

  useEffect(() => {
    if (!licenses.length) {
      axios
        .get('/licenses/licenses.json')
        .then(({ data }) => {
          const arrayList = Object.keys(data).map((item) => {
            return { name: item, ...data[item] }
          })
          setIsLoading(false)
          setLicenses(arrayList)
        })
        .catch(() => setIsLoading(false))
    }
  }, [licenses])

  return (
    <Suspense fallback={<Spinner fullPage />}>
      {isLoading && <Spinner fullPage />}
      <ContentSection>
        <PageWrap>
          <div className="u-mb-large">
            <div className="c-table-wrapper u-mv c-table--colored c-table--sticky-head">
              <Table>
                <Table.Thead>
                  <Table.Tr>
                    <Table.Th className="c-table__cell--highlight">
                      Komponente
                    </Table.Th>
                    <Table.Th className="c-table__cell--highlight">
                      Version
                    </Table.Th>
                    <Table.Th className="c-table__cell--highlight">
                      Copyright
                    </Table.Th>
                  </Table.Tr>
                </Table.Thead>
                <Table.Tbody>
                  {licenses &&
                    licenses.map((license) => {
                      const pattCustom = /^Custom:/g
                      const licenseVersion = license.name.split('@').pop()
                      const licenseName = license.name.replace(
                        `@${licenseVersion}`,
                        ''
                      )
                      const licenseLicense = pattCustom.test(
                        license.licenses
                      ) ? (
                        <a
                          href={license.licenses.replace('Custom: ', '')}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Custom
                        </a>
                      ) : (
                        license.licenses
                      )
                      return (
                        <Table.Tr key={license.name}>
                          <Table.Td className="u-text-fs-2">
                            <a
                              href={license.repository}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              {licenseName}
                            </a>
                          </Table.Td>
                          <Table.Td className="u-text-fs-2">
                            {licenseVersion}
                          </Table.Td>
                          <Table.Td className="u-text-fs-2">
                            {licenseLicense}
                          </Table.Td>
                        </Table.Tr>
                      )
                    })}
                </Table.Tbody>
              </Table>
            </div>
          </div>
        </PageWrap>
      </ContentSection>
    </Suspense>
  )
}

export default ThirdPartyLicensePage
